class DevIngredientsBreakdown extends HTMLElement {
  connectedCallback() {
    this.clamp = this.querySelector('[data-clamp]');
    this.toggle = this.querySelector('[data-toggle]');
    this.label = this.querySelector('[data-toggle-label]');
    this.fade = this.querySelector('[data-fade]');

    // Nothing to wire up if collapse is disabled (no toggle rendered)
    if (!this.clamp || !this.toggle) return;

    this.labelMore = this.toggle.dataset.labelMore || 'View More';
    this.labelLess = this.toggle.dataset.labelLess || 'Hide Info';
    this.expanded = this.clamp.classList.contains('is-expanded');

    this.toggle.addEventListener('click', () => this.toggleExpand());

    // Deferred so fonts/layout have settled before measuring
    requestAnimationFrame(() => this.hideToggleIfContentFits());
  }

  hideToggleIfContentFits() {
    if (this.expanded) return;
    if (this.clamp.scrollHeight <= this.clamp.clientHeight + 1) {
      this.toggle.hidden = true;
      this.clamp.classList.add('is-expanded');
      if (this.fade) this.fade.hidden = true;
    }
  }

  toggleExpand() {
    this.expanded = !this.expanded;
    this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
    if (this.label) this.label.textContent = this.expanded ? this.labelLess : this.labelMore;

    const full = this.clamp.scrollHeight;

    if (this.expanded) {
      // animate from the collapsed height up to the full content height
      this.clamp.classList.add('is-expanded');
      this.clamp.style.maxHeight = full + 'px';
      this.clamp.addEventListener(
        'transitionend',
        () => {
          if (this.expanded) this.clamp.style.maxHeight = 'none';
        },
        { once: true }
      );
    } else {
      // pin the current height, then transition back down to the collapsed value
      this.clamp.style.maxHeight = full + 'px';
      void this.clamp.offsetHeight; // force reflow to register the start height
      this.clamp.classList.remove('is-expanded');
      this.clamp.style.maxHeight = '';
      this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

if (!customElements.get('dev-ingredients-breakdown')) {
  customElements.define('dev-ingredients-breakdown', DevIngredientsBreakdown);
}
